export default __webpack_public_path__ + "static/media/banner-strategic-plan-mobile.4ef81dd4.png";